import { grayPalette } from '../../themes/colors';

export const dividerLightTheme = {
  color: grayPalette[900],
};
